<template>
  <section v-if="comments.length > 0" class="flex flex-col gap-3">
    <comment v-for="comment in comments" :comment="comment" @delete="$emit('delete', $event)" />
  </section>
</template>


<script>

import Comment from './comment.vue';

export default {
  name: "Comments",
  components: {
    Comment
  },
  props: {
    comments: {
      type: Array,
      default: []
    }
  },
};
</script>